import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getThumbInfo } from '../lib/icons';
import { prepUrl } from '../api/utils';

const FileThumb = ({ type, thumb, onError }) => {
  const { width, height } = getThumbInfo(type);

  return (
    <div className="iconwrap">
      <img src={prepUrl(thumb)} width={width} height={height} onError={onError}/>
    </div>
  );
}

export default FileThumb;
